import {
  ExtendedIngredientDTO,
  IIngredientDocStockDTO,
  IngredientDocStockDTO,
  LiquidClassDTO,
} from 'business/models/Models';
import { IDropDownList } from 'components/customComponents/CommonComponents/RMDropDownList';
import {
  IngredientsModalDisplayNames,
  MergeIngredientType,
  MergeStockType,
} from './IngredientEnums';
import { AddMergeIngredientProps } from './mergeIngredients/MergeIngredientConstants';

export type GetSaveDiscardButtonsParams = {
  enableButtons: boolean;
  onSave: (...args) => void;
  onDiscard: (...args) => void;
};

export type GetIngredientHeaderButtonsParams = {
  isDisabled: boolean;
  modelRefCurrent: () => void;
  addIngredientType: () => void;
  addVendor: () => void;
  addLiquidClass: () => void;
  printLabels: () => void;
  exportsList: IDropDownList[];
  mergeIngredients: () => void;
  isMergeIngredientDisabled: boolean;
  isDeleteDisabled: boolean;
  showDeleteIngredientWarning: () => void;
  openIngredient: () => void;
  isOpenIngredientDisabled: boolean;
  createIngredient: () => void;
  addProteinType: () => void;
};

export type IngredientTableRow = {
  concUnit: string;
  defaultBufferIngredientStockId: number;
  defaultNonBufferIngredientStockId: number;
  defaultStockNumber: number;
  highConc: number;
  id: number;
  isBuffer: boolean;
  liquidClassName: string;
  liquidClassId: number;
  lowConc: number;
  name: string;
  shortName: string;
  stockConc: number;
  stockId: number;
  stockMaxPh: number;
  stockMinPh: number;
  type: string;
};

export type AddIngredientTypeProps = {
  showIngredientTypeModal: boolean;
  setShowIngredientTypeModal: () => void;
};

export type GetExportButtonsListParams = {
  exportIngredientsToExcel: () => void;
  exportIngredientsToText: () => void;
  exportIngredientsToDoc: () => void;
  exportIngredientsToXML: () => void;
  exportIngredientsToXMLSpreadsheet: () => void;
};

export interface MergeIngredientsProps {
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  ingredients: ExtendedIngredientDTO[];
  setIngredients: (value: ExtendedIngredientDTO[]) => void;
}

export interface MergeStocksTable {
  ingredientName: string;
  stockConc: number;
  concUnits: string | undefined;
  pH: number | undefined;
  lowConc: number;
  highConc: number;
  vendor?: string | undefined;
  vendorPart: string | undefined;
}

export interface MergeIngredientSectionProps {
  ingredient: ExtendedIngredientDTO;
  tempIngredient: ExtendedIngredientDTO;
  setTempIngredient?: (value: ExtendedIngredientDTO) => void;
  setMergeIngredient: (value: ExtendedIngredientDTO) => void;
  onClickAdd?: (value: AddMergeIngredientProps) => void;
  onClickDelete?: (value: any) => void;
  heading: string;
  buttonText: string;
  showButtons: boolean;
  mergeIngredientType: MergeIngredientType;
  setMergeIngredientType: (value: MergeIngredientType) => void;
  currentMergeIngredientType: MergeIngredientType;
  onClickButton: (value: MergeIngredientType) => void;
}

export interface MergeIngredientItemsListProps {
  name: string;
  iterator: any;
  selectedIteratorItems: any;
  onClickAdd: (value: AddMergeIngredientProps) => void;
  onClickDelete: (value: any) => void;
  showButtons?: boolean;
  propertyName?: string;
  tempIngredient: ExtendedIngredientDTO;
  setTempIngredient?: (value: ExtendedIngredientDTO) => void;
  ingredient: ExtendedIngredientDTO;
  mergeIngredientType: MergeIngredientType;
  currentMergeIngredientType: MergeIngredientType;
  setMergeIngredientType: (value: MergeIngredientType) => void;
  setMergeIngredient: (value: ExtendedIngredientDTO) => void;
}

export interface MergeStockSectionProps {
  stock?: IIngredientDocStockDTO;
  tempStock?: IIngredientDocStockDTO;
  setTempStock?: (value: IngredientDocStockDTO) => void;
  onClickAdd?: (value: any, property: string) => void;
  onClickDelete?: (value: any) => void;
  heading: string;
  buttonText: string;
  showButtons?: boolean;
  mergeStockType?: MergeStockType;
  setCurrentMergeStockType?: (value: MergeStockType) => void;
  currentMergeStockType?: MergeStockType;
  onClickButton?: (value: MergeStockType) => void;
  liquidClasses?: LiquidClassDTO[];
}
export const columns: {
  accessor: string;
  Header: string;
  Filter?: (event: any) => JSX.Element;
}[] = [
  {
    accessor: 'ingredientName',
    Header: 'Ingredient Name',
  },
  {
    accessor: 'stockConc',
    Header: 'Stock Conc.',
  },
  {
    accessor: 'concUnits',
    Header: 'Conc. Units',
  },
  {
    accessor: 'pH',
    Header: 'pH',
  },
  {
    accessor: 'lowConc',
    Header: 'Low Conc.',
  },
  {
    accessor: 'highConc',
    Header: 'High Conc.',
  },
  {
    accessor: 'vendor',
    Header: 'Vendor',
  },
  {
    accessor: 'vendorPart',
    Header: 'Vendor Part',
  },
];

export const NAME_MAX_LENGTH = 50;
export const EMPTY_NAME_ERROR = 'Name cannot be empty.';
export const getMaxLengthError = (modalTypeName) =>
  `The ${IngredientsModalDisplayNames[modalTypeName]} name can not exceed a maximum length of ${NAME_MAX_LENGTH} characters.`;
